<div class="flex flex-col h-full w-full justify-start items-start gap-6 pb-6 bg-[#FFF]">
  <app-loi-check-stepper #stepper (selectedStepChange)="navigateToDetailCheckReport()" [nextStepAllowed]="true"
                         [previousStepAllowed]="true"
                         [selectedStep]="0"
                         [detailCheckLabel]="detailCheckLabel"
                         class="w-full"></app-loi-check-stepper>

  <div class="w-full px-6">
    <app-overview-reports (download)="downloadReport()"
                          (open)="openPressed()"
                          [activateDownload]="!loading"
                          [activateOpen]="!loading"
                          [checkerName]="checkerName"
                          [completedValue]="totalCompleted()"
                          [date]="check.checkDate"
                          [errorValue]="totalError()"
                          [fileId]="check.projectFile?.id ?? ''"
                          [info1]="fileSize"
                          [info2]="fileName"
                          [loading]="loading"
                          [rules]="totalRules.toString()"
                          [warningValue]="totalWarning()"
                          checkType="BIM_BASE"
                          class="w-full">
    </app-overview-reports>
  </div>
  <div class="w-full flex-1 min-h-0 px-6 overflow-hidden">
    <div class="h-full min-h-0 overflow-x-auto overflow-y-auto border border-gray-200 rounded-md">
      <table [dataSource]="dataSource" cdk-table class="w-full table-fixed">
        <colgroup>
          <col class="w-[3%] min-w-[56px]">
          <col class="w-[38%] min-w-[280px]">
          <col class="w-[49%] min-w-[320px]">
          <col class="w-[7%] min-w-[120px]">
          <col class="w-[3%] min-w-[56px]">
        </colgroup>

        <ng-container cdkColumnDef="info">
          <th *cdkHeaderCellDef cdk-header-cell class="text-center font-medium p-4">
          </th>
          <td *cdkCellDef="let element" cdk-cell class="p-4 !overflow-visible [text-overflow:clip]">
            <fa-icon [icon]="faCircleInfo" [tooltipDirection]="'right'"
                     [tooltipSubtext]="element.rule_description"
                     [tooltip]="element.rule_name"
                     class="text-gray-300 text-base cursor-pointer"></fa-icon>
          </td>
        </ng-container>

        <ng-container cdkColumnDef="rule">
          <th *cdkHeaderCellDef cdk-header-cell class="text-left font-medium p-4 whitespace-nowrap">
            PRÜFREGEL
          </th>
          <td *cdkCellDef="let element" cdk-cell class="text-left p-4">{{ element.rule_name }}</td>
        </ng-container>

        <ng-container cdkColumnDef="result">
          <th *cdkHeaderCellDef cdk-header-cell class="text-left font-medium p-4 whitespace-nowrap">
            ERGEBNIS
          </th>
          <td *cdkCellDef="let element" cdk-cell class="text-left p-4 text-gray-500">{{ element.text }}</td>
        </ng-container>

        <ng-container cdkColumnDef="state">
          <th *cdkHeaderCellDef cdk-header-cell class="text-center font-medium p-4 whitespace-nowrap !overflow-visible [text-overflow:clip]">
            PRÜFSTATUS
          </th>
          <td *cdkCellDef="let element" [tooltipDirection]="'bottom'"
              [tooltip]=" element.status ==='success' ? 'Erfüllt' : element.status ==='warning' ? 'Teilweise Erfüllt' : 'Nicht Erfüllt'"
              cdk-cell
              class="text-center p-4">
            @switch (element.status) {
              @case ("success") {
                <fa-icon [icon]="faCircleCheck" class="text-green text-base"></fa-icon>
              }
              @case ("warning") {
                <fa-icon [icon]="faCircleExclamation" class="text-yellow text-base"></fa-icon>
              }
              @case ("error") {
                <fa-icon [icon]="faCircleXmark" class="text-red text-base"></fa-icon>
              }
            }
          </td>
        </ng-container>

        <ng-container cdkColumnDef="task">
          <th *cdkHeaderCellDef cdk-header-cell class="text-center font-medium p-4"></th>
          <td *cdkCellDef="let element" cdk-cell class="text-center p-4 !overflow-visible [text-overflow:clip]">
            <button (click)="createTask(element)"
                    [tooltipDirection]="'left'"
                    [tooltip]="'Aufgabe erstellen'"
                    class="p-2 text-base hover:bg-gray-100 rounded transition opacity-0 group-hover:opacity-100">
              <fa-icon [icon]="faClipboardCheck" class="text-gray"></fa-icon>
            </button>
          </td>
        </ng-container>

        <tr *cdkHeaderRowDef="displayedColumns; sticky: true" cdk-header-row
            class="bg-gray-50 text-gray-500 text-xs"></tr>
        <tr (click)="setGuids(row)" *cdkRowDef="let row; columns: displayedColumns" cdk-row
            class="border-b border-gray-200 hover:bg-gray-100 cursor-pointer group"></tr>
      </table>

      @if (loading) {
        <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
          <div class="flex flex-row items-center gap-2">
            <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
            <span class="text-sm font-medium text-gray-500">Ergebnisse werden geladen...</span>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="flex flex-row w-full justify-center items-center">
    <bic-button (click)="navigateToDetailCheckReport()">
      {{ detailCheckLabel }}
      <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
    </bic-button>
  </div>

</div>
